import { render } from "./CodemirrorEditor.vue?vue&type=template&id=1df4df96"
import script from "./CodemirrorEditor.vue?vue&type=script&lang=js"
export * from "./CodemirrorEditor.vue?vue&type=script&lang=js"

import "./CodemirrorEditor.vue?vue&type=style&index=0&id=1df4df96&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__